import { getRuntimeConfig } from "~/config/runtime.config";

/**
 * Redirect to the login page
 */
function login() {
  window.location.href = `${getRuntimeConfig().LXC_AS_DEVICE_URL}/login?redirectUri=${encodeURIComponent(window.location.href)}`;
}

/**
 * Redirect to the logout page
 */
function logout() {
  window.location.href = `${getRuntimeConfig().LXC_AS_DEVICE_URL}/logout?redirectUri=${encodeURIComponent(window.location.href)}`;
}

export { login, logout };
